import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Haupt-Bridge-Komponente: liegt im Mobile-Layout auf jeder Seite. Die native App antwortet auf das
// initiale "connect" mit Lifecycle-Callbacks, die hier als Window-Events weitergegeben werden.
//
// Connects to data-controller="native--bridge"
export default class extends BridgeComponent {
  static component = "bridge"

  connect() {
    super.connect()

    // Die App kann erst hochsenden, wenn einmal etwas runtergesendet wurde.
    this.send("connect", {}, (message) => {
      const callbackReason = message.data.callbackReason
      switch (callbackReason) {
        case "didEnterForeground":
          window.dispatchEvent(new CustomEvent("mobileapp:didEnterForeground"))
          break
        case "didFinishDownload":
          window.dispatchEvent(new CustomEvent("mobileapp:didFinishDownload", { detail: message.data }))
          break
        default:
          console.log("native--bridge: unknown callbackReason " + callbackReason)
      }
    })
  }
}
